import { configureStore } from '@reduxjs/toolkit'
import timersReducer from './features/timers/timersSlice';
import websocketReducer from './features/websocket/websocketSlice';

const store = configureStore({
    reducer: {
        timers: timersReducer,
        websocket: websocketReducer
    }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store